<!--
 * @Description: 申请 查看详情
 * @Author: peifu
 * @Date: 2022-12-21 13:50:33
 * @LastEditors: PF
 * @LastEditTime: 2025-07-17 14:40:32
-->

<template>
  <div>
    <!-- 审批 开始 -->
    <el-drawer :model-value="isSPXQ" size="500px" :before-close="handleClose">
      <template #title>
        <h4>{{title}}</h4>
      </template>
      <template #default>
        <div class="ka_pian">
          <div style="display: flex;align-items: flex-end;justify-content: space-between;">
            <h3>{{sqrxm}}{{sqbdmc}}</h3>
            <!-- 状态：0-未开始，1-审批中，3-办理中，9-通过，10-拒绝，11- 终止-->
            <div>
              <h5 v-if="zhuangTai === 9" style="position: absolute;right: 0;top: -2em;z-index: 9;color:#67C23A">
                <i class="iconfont icon-yitongguo" style="font-size: 5em;"></i>
              </h5>
              <h5 v-else-if="zhuangTai === 10" style="position: absolute;right: 0;top: -2em;z-index: 9;color:#F56C6C">
                <i class="iconfont icon-yijujue" style="font-size: 5em;"></i>
              </h5>
              <h5 v-else-if="zhuangTai === 11" style="position: absolute;right: 0;top: -2em;z-index: 9;color:#F56C6C">
                <i class="iconfont icon-yizhongzhi" style="font-size: 5em;"></i>
              </h5>
              <h5 v-else style="color:#E6A23C">等待我处理</h5>
            </div>
          </div>
        </div>
        <div class="ka_pian biao_dan">
          <div v-for="(item, index) in listBdzj" :key="index">
            <span>
              <span style="color:#202020">{{item.bt}}：</span>
              <span v-for="(val, i) in item.listBdz" :key="i">
                <span v-if="item.lx === 8 && i !== 0"> 至 </span>
                <span v-else-if="i !== 0">，</span>
                {{val}}
              </span>
            </span>
          </div>
        </div>
        <div class="ka_pian liu_cheng">
          <p style="margin-bottom: 20px;">流程</p>
          <el-timeline>
            <el-timeline-item v-for="(activity, index) in listSplzbz" :key="index" :type="activity.type" :icon="activity.icon">
              <div style="display: flex; justify-content: space-between;">
                <span>{{ activity.mc }}</span>
                <span>{{ activity.tgsj }}</span>
              </div>
              <p v-if="activity.czrxms">
                <span>（{{ activity.czrxms }}）</span>
                <!-- <span v-if="activity.spfs === 1">全部审批通过</span> -->
                <span v-if="activity.spfs === 2">任意一人审批通过</span>
                <span v-if="activity.spfs === 9">按百分比例通过</span>
                <span v-if="activity.bfbtgz">{{activity.bfbtgz}}%</span>
              </p>
              <p>
                <!-- 审批类型：1-人工审批，2-自动通过，3-自动拒绝 -->
                <span v-if="activity.splx === 2">自动通过</span>
                <span v-if="activity.splx === 3">自动拒绝</span>
              </p>
              <div v-if="activity.listCzrSpYj">
                <el-row v-for="(item, i) in activity.listCzrSpYj" :key="i" :gutter="10">
                  <!-- <el-col :span="12">
                  {{ item.sprxm }}
                </el-col>
                <el-col :span="12" style="text-align: right;">
                  {{ item.spsj }}
                </el-col> -->
                  <el-col :span="4">
                    {{ item.sprxm }}
                  </el-col>
                  <el-col :span="17">
                    <div :class="item.isXianShi ? '' : 'beyond-hidden-single'">
                      {{item.spryj}}
                    </div>
                  </el-col>
                  <el-col :span="3" v-if="item.spryj">
                    <div v-if="item.spryj.length ? item.spryj.length > 20 : 0" style="text-align: right;" @click="xianShiClick(index, i)">
                      <el-link v-if="item.isXianShi" type="primary">隐藏</el-link>
                      <el-link v-else type="primary">显示</el-link>
                    </div>
                  </el-col>
                </el-row>
              </div>
            </el-timeline-item>
          </el-timeline>
        </div>
      </template>
      <template #footer>
        <div style="flex: auto; display: flex; justify-content: space-between;">
          <el-button type="primary" v-if="dbsqid" @click="chaKanXiangQing()">查看详情</el-button>
          <div v-else></div>
          <div class="dialog-footer">
            <div class="footer_but" v-if="lx === 'db'">
              <el-button type="primary" @click="yongYiClick(1)">同意</el-button>
              <el-button @click="yongYiClick(2)">拒绝</el-button>
            </div>
          </div>
        </div>
      </template>
    </el-drawer>
    <yijian v-if="isYiJian" v-model:isYiJian="isYiJian" :row="yiJianObj" @yiJianReturn="handleClose" />
    <!-- 查看详情 -->
    <jiaozhigongqingjia v-if="openJzgqjDetail" v-model:openDetail="openJzgqjDetail" :row="row" />
    <kaoshijiahuashenpi v-if="openKsjhspDetail" v-model:openDetail="openKsjhspDetail" :row="row" />
    <paikaijihuashenpi v-if="openPkjhspDetail" v-model:openDetail="openPkjhspDetail" :row="row" />
    <xueshengqingjia v-if="openXsqjDetail" v-model:openDetail="openXsqjDetail" :row="row" />
    <xueshengshixishenqing v-if="openXssxsqDetail" v-model:openDetail="openXssxsqDetail" :row="row" />
    <xueshengxuejiyidong v-if="openXsxjydDetail" v-model:openDetail="openXsxjydDetail" :row="row" />
    <yongyin v-if="openYysqqDetail" v-model:openDetail="openYysqqDetail" :row="row" />
  </div>
</template>

<script setup>
import { defineEmits, ref, defineProps, watch } from 'vue'
import { biaodanshenpiliucheng } from '@/api/home'
import { warningPrompt } from '@/utils/promptInfo'
import yijian from './yijian'
import jiaozhigongqingjia from '@/components/home/changguishiwu/tongyong/qingjia/detail.vue'
import kaoshijiahuashenpi from '@/pages/jiaoxue/kaowuguanli/kaoshijihua/detail.vue'
import paikaijihuashenpi from '@/pages/jiaoxue/kaowuguanli/paikaoguanli/detail.vue'
import xueshengqingjia from '@/components/home/changguishiwu/banzhuren/xueshengqingjia/detail.vue'
import xueshengshixishenqing from '@/pages/shixijiuye/shixiqianyewu/shenheshixishenqing/detail.vue'
import xueshengxuejiyidong from '@/pages/jiaowu/xuejiguanli/xuejiyidong/detail.vue'
import yongyin from '@/components/home/changguishiwu/tongyong/yongyinshenqing/detail.vue'

const props = defineProps({ isSPXQ: { type: Boolean, required: true }, SPXQObj: { type: Object, required: false } })
const emits = defineEmits(['update:isSPXQ', 'xiangQingReturn', 'ReturnData'])

const title = ref('')
const type = ref('')
const lx = ref('')
const ryid = ref('') // 人员id
const sqrxm = ref('') // 申请人姓名
const sqbdmc = ref('') // 申请表单名称
const listBdzj = ref([]) // 申请表单组件
const listSplzbz = ref([]) // 审批流转步骤
const zhuangTai = ref(0) // 状态
const dbsqid = ref('') // 详情id

// 显示全部意见
const xianShiClick = (val) => {
  listSplzbz.value.forEach((element, index) => {
    if (val === index) {
      element.listCzrSpYj.forEach((e) => {
        e.isXianShi = !e.isXianShi
      })
    }
  })
}
// 同意
const isYiJian = ref(false)
const yiJianObj = ref()
const yongYiClick = (type) => {
  isYiJian.value = true
  switch (type) {
    case 1:
      yiJianObj.value = {
        title: '审批意见',
        type: type,
        ryid: ryid.value
      }
      break
    case 2:
      yiJianObj.value = {
        title: '审批意见',
        type: type,
        ryid: ryid.value
      }
      break
    case 3:
      yiJianObj.value = {
        title: '办理意见',
        ryid: ryid.value
      }
      break
  }
}
// 查看预定义审批详情
const row = ref()
const openJzgqjDetail = ref(false)
const openKsjhspDetail = ref(false)
const openPkjhspDetail = ref(false)
const openXsqjDetail = ref(false)
const openXssxsqDetail = ref(false)
const openXsxjydDetail = ref(false)
const openYysqqDetail = ref(false)
const chaKanXiangQing = () => {
  row.value = { id: dbsqid.value }
  switch (sqbdmc.value) {
    case '教职工请假': // 教职工请假
      openJzgqjDetail.value = true
      break
    case '教职工销假': // 教职工销假
      openJzgqjDetail.value = true
      break
    case '考试计划审批': // 考试计划审批
      openKsjhspDetail.value = true
      break
    case '排考计划审批': // 排考计划审批
      openPkjhspDetail.value = true
      break
    case '学生请假-班主任发起': // 学生请假-班主任发起
      openXsqjDetail.value = true
      break
    case '学生请假-学生发起': // 学生请假-学生发起
      openXsqjDetail.value = true
      break
    case '学生实习申请审批': // 学生实习申请审批
      openXssxsqDetail.value = true
      break
    case '学生学籍异动申请审批': // 学生学籍异动申请审批
      openXsxjydDetail.value = true
      break
    case '办公-用印申请': // 办公-用印申请
      openYysqqDetail.value = true
      break
  }
}
// 关闭
const handleClose = () => {
  emits('update:isSPXQ', false)
  emits('xiangQingReturn')
  emits('ReturnData')
}
// 获取详情
const initInfo = (val) => {
  const info = {
    id: val
  }
  biaodanshenpiliucheng(info).then((res) => {
    if (res.code === 200) {
      sqrxm.value = res.data.sqrxm
      sqbdmc.value = res.data.sqbdmc
      listBdzj.value = res.data.listBdzj
      dbsqid.value = res.data.dbsqid
      if (res.data.listSplzbz && res.data.listSplzbz.length) {
        res.data.listSplzbz.forEach((val) => {
          // 状态：0-未开始，1-审批中，3-办理中，9-通过，10-拒绝
          if (val.zt === 1) {
            val.type = 'warning'
            val.icon = 'MoreFilled'
            ryid.value = val.id
            zhuangTai.value = val.zt
            // } else if (val.zt === 3) {
            //   val.type = 'warning'
            //   val.icon = 'MoreFilled'
            //   ryid.value = val.id
            //   zhuangTai.value = val.zt
          } else if (val.zt === 9) {
            val.type = 'success'
            val.icon = 'Select'
            zhuangTai.value = val.zt
          } else if (val.zt === 10) {
            val.type = 'danger'
            val.icon = 'CloseBold'
            zhuangTai.value = val.zt
          } else if (val.zt === 11) {
            val.type = 'danger'
            val.icon = 'CloseBold'
            zhuangTai.value = val.zt
          }
        })
        listSplzbz.value = res.data.listSplzbz
        zhuangTai.value = res.data.zt ? res.data.zt : zhuangTai.value
      }
    } else {
      warningPrompt(res.message)
    }
  })
}
watch(
  () => props.isSPXQ,
  () => {
    if (props.isSPXQ) {
      title.value = props.SPXQObj.title || ''
      type.value = props.SPXQObj.type || ''
      lx.value = props.SPXQObj.lx
      initInfo(props.SPXQObj.id)
    }
  },
  { deep: true, immediate: true }
)
</script>

<style lang="less" scoped>
// @import '@/assets/css/tanchuangbuju.less';
// @import '@/assets/css/publicList.less';

// 详情 开始
:deep(.el-drawer__header) {
  margin-bottom: 15px;
}
:deep(.el-drawer__body) {
  background-color: #f4f4f5;
  padding: 10px 0;
  .ka_pian {
    padding: 10px 20px;
    background-color: #fff;
    margin-bottom: 10px;
  }
  .biao_dan {
    color: #909399;
    font-size: 14px;
  }
  .el-timeline-item__wrapper {
    display: flex;
    justify-content: space-between;
  }
  .el-timeline-item__node {
    left: -5px;
    width: 20px;
    height: 20px;
  }
  .el-timeline-item__content {
    width: 100%;
    p:nth-child(2) {
      color: #909399;
    }
  }
}
.el-drawer__footer {
  .el-dialog__footer {
    .el-button--danger {
      width: 130px;
      height: 38px;
      margin: 4px;
      color: #fff;
      background-color: #0d6efd;
      border: 1px solid #0d6efd;
      padding: 22px 22px;
      font-size: 18px;
      font-weight: 400;
      line-height: 1px;
      display: inline-block;
      text-align: center;
      text-decoration: none;
      vertical-align: middle;
      border-radius: 0.375rem;
      transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,
        border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
    }
  }
}

// 详情 结束
</style>
